__turbopack_context__.v({
  "brand": "index-module-scss-module__xTAFLq__brand",
  "brandFallback": "index-module-scss-module__xTAFLq__brandFallback",
  "brandImage": "index-module-scss-module__xTAFLq__brandImage",
  "category": "index-module-scss-module__xTAFLq__category",
  "close": "index-module-scss-module__xTAFLq__close",
  "closeButton": "index-module-scss-module__xTAFLq__closeButton",
  "container": "index-module-scss-module__xTAFLq__container",
  "expanded": "index-module-scss-module__xTAFLq__expanded",
  "header": "index-module-scss-module__xTAFLq__header",
  "nav": "index-module-scss-module__xTAFLq__nav",
  "overlay": "index-module-scss-module__xTAFLq__overlay",
  "title": "index-module-scss-module__xTAFLq__title",
  "toggle": "index-module-scss-module__xTAFLq__toggle",
});
